import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RenderAd } from '@pickleballinc/ui/components/advertisements/render-ad';
import { Fragment } from 'react';

import { RenderAlert } from '@/modules/homepage/RenderAlert/RenderAlert';
import { RenderBlock } from '@/modules/homepage/RenderBlock/RenderBlock';
import { RenderCarousel } from '@/modules/homepage/RenderCarousel/RenderCarousel';
import { LoadMoreButton } from '@/modules/homepage/RenderContentArea/LoadMoreButton';
import { RenderExternalNews } from '@/modules/homepage/RenderExternalNews/RenderExternalNews';
import { RenderImage } from '@/modules/homepage/RenderImage/RenderImage';
import { RenderNews } from '@/modules/homepage/RenderNews/RenderNews';
import { RenderVideo } from '@/modules/homepage/RenderVideo/RenderVideo';
import { ZONE_IDS_PB } from '@/types/ads.types';
import { ColumnWidgetTypes } from '@/types/homepage.types';
import { ColumnInterfaceExtended } from '@/utils/actions/homepage/getHomepageStructure';
import { IS_PRODUCTION } from '@/utils/helpers/constants';

export interface RenderContentAreaProps extends ColumnInterfaceExtended {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  isLoading: boolean;
}

export const RenderContentArea = ({
  ipAddress,
  type,
  widgets,
  nextPage,
  currentPage,
  setCurrentPage,
  isLoading,
}: RenderContentAreaProps) => {
  return (
    <div key={type} className='w-full max-w-screen-sm flex-1'>
      <div className='flex w-full flex-col gap-4 px-0.5 pt-4 sm:mx-auto sm:w-[640px] sm:px-0 sm:pt-6'>
        {widgets.map((widget) => (
          <Fragment key={widget.uuid}>
            {widget.type === ColumnWidgetTypes.BLOCK ? (
              <RenderBlock {...widget.metadata} />
            ) : widget.type === ColumnWidgetTypes.NEWS && widget.metadata.prefetchedData ? (
              <RenderNews newsType={widget.metadata.newsType} {...widget.metadata.prefetchedData} />
            ) : widget.type === ColumnWidgetTypes.VIDEO ? (
              <RenderVideo {...widget.metadata} />
            ) : widget.type === ColumnWidgetTypes.IMAGE ? (
              <RenderImage {...widget.metadata} />
            ) : widget.type === ColumnWidgetTypes.EXTERNAL_NEWS ? (
              <RenderExternalNews
                url={widget.metadata.url}
                newsType={widget.metadata.newsType}
                {...(widget.metadata.prefetchedData
                  ? widget.metadata.prefetchedData
                  : widget.metadata)}
              />
            ) : widget.type === ColumnWidgetTypes.MIDDLE_ADVERTISEMENT ? (
              ZONE_IDS_PB.FLOATING_VIDEO === widget.metadata.zoneId ||
              ZONE_IDS_PB.HOMEPAGE_VIDEO === widget.metadata.zoneId ? null : (
                // <RenderVideoAd
                //   ipAddress={ipAddress}
                //   pageId={100000}
                //   place={widget.metadata.place ? +widget.metadata.place : 0}
                //   zoneId={widget.metadata.zoneId}
                //   isProd={IS_PRODUCTION}
                // />
                <RenderAd
                  height={+widget.metadata.height}
                  ipAddress={ipAddress}
                  pageId={100000}
                  place={widget.metadata.place ? +widget.metadata.place : 0}
                  width={+widget.metadata.width}
                  placementId={widget.metadata.placementId}
                  zoneId={widget.metadata.zoneId}
                  isProd={IS_PRODUCTION}
                />
              )
            ) : widget.type === ColumnWidgetTypes.CAROUSEL && widget.metadata.prefetchedData ? (
              <RenderCarousel carouselNews={widget.metadata.prefetchedData} />
            ) : widget.type === ColumnWidgetTypes.ALERT ? (
              <RenderAlert {...widget.metadata} />
            ) : null}
          </Fragment>
        ))}
      </div>
      {nextPage !== 'no next page' && (
        <div className='my-8 flex w-full justify-center'>
          {isLoading ? (
            <div className='flex h-[36px] w-full items-center justify-center'>
              <FontAwesomeIcon icon={faSpinnerThird} spin className='text-gray-500' size='xl' />
            </div>
          ) : (
            <LoadMoreButton currentPage={currentPage} setCurrentPage={setCurrentPage} />
          )}
        </div>
      )}
    </div>
  );
};
